import { environment } from '../../../../environments/environment';

/**
 * Fonte única da montagem de URL da API Perfil Investimento.
 *
 * Combina, nesta ordem: `environment.baseUrl` + `environment.apiGatewayPrefix`
 * (segmento do gateway Azure, ex.: `apis`) + `environment.apiPerfilInvestimentoUrl`
 * + o `path` informado. Segmentos vazios são omitidos, então a mesma função serve:
 *
 * - back remoto (HML/prod): `https://homologacao.vivest.com.br/apis/api-perfil-investimento/v1/Campanha`
 * - back local (Kestrel):   `https://localhost:50592/api-perfil-investimento/v1/Campanha`
 *
 * Sem o `${baseUrl}` a URL fica relativa e o browser a resolve contra o host do
 * front (ex.: `perfil-investimento-administrativo-dev...`), gerando 404.
 *
 * Função pura: não valida configuração. Quem precisa falhar quando
 * `apiPerfilInvestimentoUrl` está vazio (ex.: `HttpClientService`) deve checar
 * antes de chamar.
 */
export function buildApiUrl(path: string): string {
  const origin = environment.baseUrl?.trim().replace(/\/+$/, '') ?? '';
  const gatewayPrefix = environment.apiGatewayPrefix?.trim().replace(/^\/+|\/+$/g, '') ?? '';
  const apiSegment = environment.apiPerfilInvestimentoUrl?.trim().replace(/^\/+|\/+$/g, '') ?? '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  const base = [origin, gatewayPrefix, apiSegment].filter((segment) => segment.length > 0).join('/');

  return `${base}${normalizedPath}`;
}
